module.exports = __webpack_public_path__ + "static/Zero-Tangential-Speed-a3eccef8bb83b73e9932a88970f2f46f.png";